import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { Runner } from '@pixi/runner';
var Resource = /*#__PURE__*/function () {
  function Resource() {
    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    _classCallCheck(this, Resource);
    this._width = width;
    this._height = height;
    this.destroyed = false;
    this.internal = false;
    this.onResize = new Runner("setRealSize");
    this.onUpdate = new Runner("update");
    this.onError = new Runner("onError");
  }
  _createClass(Resource, [{
    key: "bind",
    value: function bind(baseTexture) {
      this.onResize.add(baseTexture);
      this.onUpdate.add(baseTexture);
      this.onError.add(baseTexture);
      if (this._width || this._height) {
        this.onResize.emit(this._width, this._height);
      }
    }
  }, {
    key: "unbind",
    value: function unbind(baseTexture) {
      this.onResize.remove(baseTexture);
      this.onUpdate.remove(baseTexture);
      this.onError.remove(baseTexture);
    }
  }, {
    key: "resize",
    value: function resize(width, height) {
      if (width !== this._width || height !== this._height) {
        this._width = width;
        this._height = height;
        this.onResize.emit(width, height);
      }
    }
  }, {
    key: "valid",
    get: function get() {
      return !!this._width && !!this._height;
    }
  }, {
    key: "update",
    value: function update() {
      if (!this.destroyed) {
        this.onUpdate.emit();
      }
    }
  }, {
    key: "load",
    value: function load() {
      return Promise.resolve(this);
    }
  }, {
    key: "width",
    get: function get() {
      return this._width;
    }
  }, {
    key: "height",
    get: function get() {
      return this._height;
    }
  }, {
    key: "style",
    value: function style(_renderer, _baseTexture, _glTexture) {
      return false;
    }
  }, {
    key: "dispose",
    value: function dispose() {}
  }, {
    key: "destroy",
    value: function destroy() {
      if (!this.destroyed) {
        this.destroyed = true;
        this.dispose();
        this.onError.removeAll();
        this.onError = null;
        this.onResize.removeAll();
        this.onResize = null;
        this.onUpdate.removeAll();
        this.onUpdate = null;
      }
    }
  }], [{
    key: "test",
    value: function test(_source, _extension) {
      return false;
    }
  }]);
  return Resource;
}();
export { Resource };